import { orderBy } from 'lodash';
import React from 'react';

import { VendorPasscodeTableFragment } from '../../graphql/api/generated';
import { PermissionKey_enum, PermissionScope_enum } from '../../graphql/hasura/generated';
import { PropertyModel } from '../Property/model';
import { UserModel } from '../User/model';

import { VendorPasscodeRecommendation } from './components/VendorPasscodeRecommendation';
import model from './model';

export const propertiesColumn = model.createColumn<VendorPasscodeTableFragment>({
  title: 'Properties',
  filterOptions: {
    type: 'MODEL_SELECT',
    key: 'propertyId',
    model: PropertyModel,
  },
  enabled: ({ currentPermissionScope }) => (
    currentPermissionScope === PermissionScope_enum.GLOBAL ||
    currentPermissionScope === PermissionScope_enum.ORGANIZATION
  ),
  render: ({ properties }) => {
    const sortedProperties = orderBy(properties, p => p.name);

    return PropertyModel.routes.renderRowLinks(sortedProperties);
  },
  renderString: ({ properties }) => {
    const sortedProperties = orderBy(properties, p => p.name);

    return sortedProperties.map(p => PropertyModel.labels.getLabel(p)).join(', ');
  },
});

export const assignedToColumn = model.createColumn<VendorPasscodeTableFragment>({
  title: 'Assigned To',
  filterOptions: {
    type: 'MODEL_SELECT',
    key: 'assignedToUserId',
    model: UserModel,
  },
  render: ({ assignedToUser }) => UserModel.routes.renderRowLink(assignedToUser),
});

export const codeColumn = model.createColumn<VendorPasscodeTableFragment>({
  title: 'Code',
  enabled: ({ hasPermission }) => !hasPermission(PermissionKey_enum.VendorPasscode_Regenerate),
  render: ({ code }) => code,
});

export const codeWithRecommendationColumn = model.createColumn<VendorPasscodeTableFragment>({
  title: 'Code',
  enabled: ({ hasPermission }) => hasPermission(PermissionKey_enum.VendorPasscode_Regenerate),
  // @TODO: Support dynamic filter options?
  filterOptions: {
    type: 'RADIO',
    key: 'regenerationRecommended',
    options: [
      {
        label: 'Regeneration Recommended',
        queryFilters: {
          regenerationRecommended: true,
        },
      },
      {
        label: 'No Regeneration Recommended',
        queryFilters: {
          regenerationRecommended: false,
        },
      },
    ],
  },
  render: ({ code, regenerationRecommended }) => {
    if (regenerationRecommended) {
      return (
        <>
          <div>{code}</div>
          <div style={{ marginTop: 10 }}>
            <VendorPasscodeRecommendation />
          </div>
        </>
      );
    }

    return code;
  },
  renderString: ({ code, regenerationRecommended }) => {
    if (regenerationRecommended) {
      return `${code} (Regeneration Recommended)`;
    }

    return code;
  },
});

export const createdByColumn = model.createColumn<VendorPasscodeTableFragment>({
  title: 'Created By',
  filterOptions: {
    type: 'MODEL_SELECT',
    key: 'createdByUserId',
    model: UserModel,
  },
  render: ({ createdByUser }) => UserModel.routes.renderRowLink(createdByUser),
});
